import manager from '../../../Manager';
import './index.scss';

function EditorControls({slides, selectedSlide, structures, selectedSlideIndex, reRender, showModalCrop}) {
    // console.log('slide ke new index ',slides[selectedSlideIndex]);
    // console.log('selected slide ', selectedSlide);
    // console.log('structures ', structures);
    // console.log('selectedSlide ', selectedSlide);
    // console.log('selectedSlide by Index ', slides[selectedSlideIndex]);

  return (
    <div className="tbcourse-editor-controls">
            {/* <div>{selectedSlide?.id} {selectedSlide?.getValue('title')}</div> */}
            { Object.keys(structures).map((key, index) => {
                const structure = structures[key];
                const defaultValue = selectedSlide.getValue(key);
                // console.log('selectedSlide on Loop ', selectedSlide);

                return (
                    <div className="tbcourse-editor-control-item" key={index}>
                        <div className="tbcourse-editor-control-item-label">
                            {structure.label}
                        </div>
                        <div className="tbcourse-editor-control-item-control">
                            {manager.createControl(key, selectedSlide, structure, defaultValue, 'control-'+selectedSlideIndex+'-' + index, reRender, null, null, showModalCrop)}
                        </div>
                    </div>
                );
            })}
    </div>
  );
}

export default EditorControls;
